import { AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'
import reportsUrls from '../../utils/urls/reportsUrls'
const BASE_URL = process.env.REACT_APP_BACKEND_URL

const getNewCaseQuestions = (): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_URL}surveys/1/questions`)

const getVictimsQuestions = (): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_URL}surveys/1/questions/person`, {
    params: {
      type: 'question_victim',
    },
  })
const postNewCase = (answers: any): Promise<AxiosResponse> =>
  axiosInstance.post(`${BASE_URL}reports/`, answers, {
    headers: {
      'Content-Type': 'application/json',
      applicationName: 'reporter',
    },
  })

const getReportByUniqueCode = async (unique_code: string) => {
  const res = await axiosInstance.get(`${BASE_URL}reports/`, {
    params: {
      unique_code,
    },
  })
  return res
}

const getArchivedQuestions = (reportId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${reportsUrls.getReportById(reportId)}archived`)

const postVictimAnswers = (
  reportId: number,
  answers: any,
  report_type: string,
): Promise<AxiosResponse> =>
  axiosInstance.post(`${reportsUrls.getReportById(reportId)}answers`, answers, {
    params: {
      report_type,
    },
  })

const getVictimAnswers = (victimId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_URL}victims/${victimId}/answers`)

const getQuestionCaseType = (questionId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_URL}questions/${questionId}/category`)

export default {
  getNewCaseQuestions,
  getVictimsQuestions,
  postNewCase,
  getReportByUniqueCode,
  getArchivedQuestions,
  postVictimAnswers,
  getVictimAnswers,
  getQuestionCaseType,
}
